<template>
  <div />
</template>

<script>
export default {
  name: 'Share',
  created() {
    let url = (window.location.href || document.location.href).replace('amp;', '')
    url = url.replace('amp%3B')

    const inviteCode = new URL(url).searchParams.get('code')
    if (inviteCode) {
      this.$store.commit('SET_INVITE_CODE', inviteCode)
      localStorage.setItem('inviteCode', inviteCode)
    }

    const couponCode = new URL(url).searchParams.get('coupon_code')
    if (couponCode) {
      this.$store.commit('SET_COUPON_CODE', couponCode)
      localStorage.setItem('couponCode', couponCode)
    }

    const group = new URL(url).searchParams.get('group')
    if (group) {
      this.$store.commit('SET_GROUP', group)
    }

    if (this.$store.getters.token !== null) {
      // 已登入 導向會員首頁
      this.$router.push({ path: '/user' })
    } else {
      // 導回首頁
      this.$router.push({ path: '/' })
    }
  }
}
</script>
